import { OwnersEndpoints } from "../../endpoints/owners.endpoint";
import { I_CheckMatchesValuesQRTK } from "./values/ownersCheck.values";
import { mainSplitApi } from "../../mainSplitApi";
import { IOwnerDetailValuesQRTK } from "./values/ownersDetail.values";
import { IOwnerUpdateValuesQRTK } from "./values/ownersUpdate.values";
import { OwnerDetailResponses } from "./response/owner-detail.responses";
import HTransformObject from "@rf-helper/transform-object.helper";
import { IOwnerCreateValuesQRTK } from "./values/ownersCreate.values";
import OWNERS_TAG_TYPES from "./owners-tags";
import {
  IOwnerListResponses,
  IOwnerListValuesQRTK
} from "./values/ownerList.values";
import {
  IOwnerVerificationResponse,
  transformOwnerVerification
} from "./response/owner-verifited-exits.response";

export const OwnersQueryServices = mainSplitApi.injectEndpoints({
  endpoints: ({ mutation, query }) => ({
    CheckExitsOwner: mutation({
      query: (values: I_CheckMatchesValuesQRTK) => {
        return {
          url: OwnersEndpoints.CheckMatches,
          method: "GET",
          params: values.query
        };
      },
      transformResponse: (response: any, meta, arg) => response
    }),
    verifierExitsOwner: query({
      query: (values: I_CheckMatchesValuesQRTK) => {
        return {
          url: OwnersEndpoints.CheckMatches,
          method: "GET",
          params: values.query
        };
      },
      transformResponse: (response: IOwnerVerificationResponse, meta, arg) =>
        transformOwnerVerification(response)
    }),
    getDetailOwner: query({
      query: (values: IOwnerDetailValuesQRTK) => ({
        url: OwnersEndpoints.OwnerDetail(values.params.id),
        method: "GET"
      }),
      providesTags: [OWNERS_TAG_TYPES.OWNERS_DETAIL],
      transformResponse: (response: OwnerDetailResponses, meta, arg) => response
    }),
    updateOwner: mutation({
      query: (values: IOwnerUpdateValuesQRTK) => ({
        url: OwnersEndpoints.OwnerUpdate(values.params.id),
        method: "POST",
        body: HTransformObject(values.body, {
          removeEmptyStrings: true,
          removeUndefined: true
        })
      }),
      invalidatesTags: [OWNERS_TAG_TYPES.OWNERS_DETAIL],
      transformResponse: (response: any, meta, arg) => response
    }),
    CreateOwner: mutation({
      query: (values: IOwnerCreateValuesQRTK) => ({
        url: OwnersEndpoints.CreateOwner,
        method: "POST",
        body: HTransformObject(values.body, {
          removeEmptyStrings: true,
          removeNull: true,
          removeUndefined: true,
          removeEmptyArray: true
        })
      }),
      transformResponse: response => response
    }),
    getListOwner: query<IOwnerListResponses, IOwnerListValuesQRTK>({
      query: values => ({
        url: OwnersEndpoints.OwnersList,
        method: "GET",
        params: values.query
      }),
      transformResponse: (response: IOwnerListResponses) => response
    })
  })
});

export const {
  useCheckExitsOwnerMutation,
  useVerifierExitsOwnerQuery,
  useLazyVerifierExitsOwnerQuery,
  useGetDetailOwnerQuery,
  useUpdateOwnerMutation,
  useCreateOwnerMutation,
  useGetListOwnerQuery
} = OwnersQueryServices;
